import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOData from '@/components/feature/SEOData';
import HeroSection from './components/HeroSection';
import HotRecommend from './components/HotRecommend';
import CategorySection from './components/CategorySection';
import LatestSection from './components/LatestSection';
import FAQSection from './components/FAQSection';
import { useScrollToTop } from '@/hooks/useScrollToTop';

export default function Home() {
  useScrollToTop();

  return (
    <>
      <SEOData
        pageType="home"
        title="龙禁漫 - 正版漫画资源平台官方入口 | 海量漫画在线阅读与下载"
        description="龙禁漫是专注于正版漫画内容的综合平台，提供海量漫画资源在线阅读与下载。无论你喜欢热血、恋爱、悬疑还是奇幻题材，龙禁漫都能满足你的阅读需求，立即访问龙禁漫，开启你的漫画之旅。"
        canonical="https://longjinman.com"
      />
      <Navbar />
      <main>
        <HeroSection />
        <HotRecommend />
        <CategorySection />
        <LatestSection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}